import styled from 'styled-components';

const CardLayout = styled.div<{ profileImg: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 230px;
  overflow: hidden;
  background-image: url(${({ profileImg }) => profileImg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 20% top;
  border-radius: 16px;
  box-shadow: 10px 10px 30px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;

  .summoner-info-wrapper {
    padding: 28px 20px 0 20px;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    height: 50%;
    background: rgba(0, 0, 0, 0.35);

    .rank {
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
      font-family: ${({ theme }) => theme.fonts.Montserrat};
      font-size: ${({ theme }) => theme.fontWeights.base};
      font-weight: ${({ theme }) => theme.fontWeights.bold};
      color: ${({ theme }) => theme.colors.yellow};
    }

    .summoner {
      width: 100%;
      margin-bottom: ${({ theme }) => theme.margins.xxl};
      padding: ${({ theme }) =>
        `${theme.paddings.base} 0 ${theme.paddings.xl} 0`};
      border-bottom: 1px solid ${({ theme }) => theme.palette.white};
      font-family: ${({ theme }) => theme.fonts.SpoqaHanSansNeo};
      font-size: ${({ theme }) => theme.fontSizes.xxxl};
      font-weight: ${({ theme }) => theme.fontWeights.bold};
      color: ${({ theme }) => theme.colors.yellow};
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .level {
      font-family: ${({ theme }) => theme.fonts.Montserrat};
      font-size: ${({ theme }) => theme.fontSizes.base};
      font-weight: ${({ theme }) => theme.fontWeights.bold};
      color: ${({ theme }) => theme.palette.white};
    }
  }

  .summoner-rank-wrapper {
    position: relative;
    height: 150px;
    font-size: ${({ theme }) => theme.fontSizes.xsmall};
    font-family: ${({ theme }) => theme.fonts.SpoqaHanSansNeo};

    .summoner-rank {
      padding: 8px 16px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      box-sizing: border-box;
      color: white;
      z-index: 1;

      .rank {
        display: flex;
        flex-flow: row wrap;

        .info-wrapper {
          margin: 3px 0;
          display: flex;
          width: calc(100% / 2);

          &:nth-of-type(2n) {
            .value {
              min-width: auto;
            }

            .label {
              text-align: right;
            }
          }

          .label {
            display: block;
            min-width: 23px;
          }

          .value {
            padding: 0 10px;
            display: block;
            font-family: ${({ theme }) => theme.fonts.Montserrat};
            min-width: 80px;
            font-size: ${({ theme }) => theme.fontSizes.xsmall};
            font-weight: ${({ theme }) => theme.fontWeights.bold};
            color: ${({ theme }) => theme.colors.mint};
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }

    .most-champs {
      width: 100%;

      .label {
        margin: 6px 0;
      }

      .champs-wrapper {
        flex-direction: row;
        display: flex;

        .champ {
          margin-right: 4px;
          width: 32px;
          height: 32px;
          border-radius: 4px;
          background-color: #212529;
          background-image: url('https://w.namu.la/s/24428541794ddb5ef9a34d0f8e656ddbd852cb2137caabf1f44713c896a311057b848c808da381e04c538573f95fafc232fae177dfbc9cf87ed70fa04fc20d86aae3047e45033ad0fd8df8a89b2f7782');
          background-repeat: no-repeat;
          background-size: cover;
          background-position: 20% top;
        }
      }
    }

    .summoner-rank-wrapper-overlay {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: ${({ theme }) => theme.palette.black};
      opacity: 0.8;
    }
  }
`;

const CardListWrapper = styled.div`
  margin-bottom: 48px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const Champ = styled.div<{ championImg: string }>`
  width: 32px;
  height: 32px;
  margin-right: 4px;
  border-radius: 4px;
  background-color: #212529;
  background-image: ${({ championImg }) => `url(${championImg})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 20% top;
`;
export { CardListWrapper, CardLayout, Champ };
